module.exports = __webpack_public_path__ + "views/hosting.3319178bcfe739db96670781f5d1b206.html";